import React from "react";

const SvgPackageEta = props => (
  <svg
    viewBox="0 0 507 507"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={2}
    {...props}
  >
    <path
      d="M376.406 363.03v-48.923c0-5.514-4.469-9.984-9.984-9.984s-9.984 4.47-9.984 9.984v53.116a9.776 9.776 0 002.796 7.086l26.657 26.661a9.749 9.749 0 006.989 2.894 10.427 10.427 0 007.09-2.894 9.958 9.958 0 002.968-7.02 9.942 9.942 0 00-2.87-7.059l-23.662-23.861zM175.723 317.302c-.016-5.507-4.478-9.969-9.985-9.985H54.913c-5.507.016-9.968 4.478-9.984 9.985v61.902c.016 5.507 4.477 9.969 9.984 9.984h110.825c5.507-.015 9.969-4.477 9.985-9.984v-61.902zm-19.969 52.916H64.898v-42.932h90.856v42.932z"
      fill="fill"
      fillRule="nonzero"
    />
    <path
      d="M417.341 225.248V147.87a9.89 9.89 0 00-.799-3.795L374.011 39.541a37.963 37.963 0 00-35.444-23.764H79.074A37.864 37.864 0 0043.63 39.541L.897 144.173A9.635 9.635 0 000 147.87v244.813c.176 21.232 17.402 38.373 38.638 38.439h217.259c24.762 35.943 66.493 60.303 113.719 60.303 75.681 0 137.385-61.602 137.385-137.381-.102-58.907-37.741-109.327-89.66-128.796zM355.439 46.826l37.043 90.759H269.177L253.401 35.746h85.065a17.998 17.998 0 0116.973 11.08zM163.742 157.554h86.863v45.128l-86.863 34.145v-79.273zm1.696-19.969l16.576-101.839h51.118l15.776 101.839h-83.47zM62.101 46.826a17.998 17.998 0 0116.973-11.08h82.772l-16.575 101.839H25.16l36.941-90.759zM38.638 411.154c-10.206-.067-18.494-8.269-18.67-18.471V157.554h123.805v93.949a9.965 9.965 0 004.392 8.288 10.479 10.479 0 005.592 1.696 9.662 9.662 0 003.694-.698l106.831-41.934a9.982 9.982 0 006.291-9.286v-52.015h126.8v61.902a134.099 134.099 0 00-27.757-2.796c-75.681 0-137.381 61.703-137.381 137.384a138.329 138.329 0 0012.379 57.008H38.638v.102zm330.88 60.205c-64.792 0-117.314-52.526-117.314-117.315 0-64.792 52.522-117.314 117.314-117.314 64.789 0 117.315 52.522 117.315 117.314.098 64.695-52.62 117.315-117.315 117.315z"
      fill="fill"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgPackageEta;
